<template>
  <div class="mb-3 mt-5">
    <b-container>
      <b-alert show variant="primary" class="text-center">{{ $t('password_reset.success') }}</b-alert>
    </b-container>
    <b-container>
      <b-alert show variant="warning" class="text-center">
        {{ $t('password_reset.mail_text1') }}
        <br>
        {{ $t('password_reset.mail_text2') }}
      </b-alert>
    </b-container>
<!--    <b-container class="col-12 col-sm-6 mb-12 mb-sm-0">-->
<!--      <b-link to="/login" class="btn btn-block btn-primary">{{ $t('password_reset.ok') }}</b-link>-->
<!--    </b-container>-->
  </div>
</template>

<script>
export default {
  name: 'PasswordResetSendMailResult'
}
</script>

<style scoped>
.text-center {
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
